import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { UpdatedTaskStatusEnum } from '@/src/components/task/Config';
import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath } from '@/src/routes';

export type MarkTaskAsUncompleteDTOResponse = {
  data: {
    error: string;
    errorDescription: string;
    success: boolean;
    currentTask: any; // Legacy task from task/Details api
  };
  status: boolean;
};

export type markTaskAsUncompleteDTO = {
  taskId: number;
  userId: number;
};

const url = `${PREFIX_URL}/tasks/:taskId/status`;

const markTaskAsUncomplete = ({
  taskId,
  userId,
}: markTaskAsUncompleteDTO): Promise<MarkTaskAsUncompleteDTOResponse> => {
  return axios.put(
    generateRoutePath(url, {
      taskId,
    }),
    {
      taskId,
      userId,
      changesRequestBy: null,
      comment: null,
      fileTagIds: [],
      status: UpdatedTaskStatusEnum.InProgress,
    }
  );
};

export const useMarkTaskAsUncomplete = () => {
  return useMutation({
    mutationFn: ({ taskId, userId }: markTaskAsUncompleteDTO) =>
      markTaskAsUncomplete({ taskId, userId }),
  });
};
